export enum EnumAutomationProvisioningStatus {
  Syncing = 'syncing',
  Ready = 'ready',
  Error = 'error',
  Unknown = 'unknown'
}
